import {Box, Grid, Typography} from '@mui/material';
import api from 'api';
import {usePostApi} from 'common/hooks/usePostApi';
import Dialog from 'components/Dialog';
import Panel from 'components/Panel';
import {AuthenticatorForm} from 'features/login/AuthenticatorForm';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {IMfaSetupResponse, _mfaSetupResp} from 'types/diplomat/authentication/MfaSetupResponse';
import {useVerifyCode} from './redux/hooks/useVerifyCode';
import {useStyles} from './styles';

export type AuthenticatorSetupDialogData = {
   qrCodeUri: string;
   recoveryCodes: string[];
};

type Props = {
   onClose: (status?: boolean) => void;
   data?: AuthenticatorSetupDialogData;
};

export const AuthenticatorSetupDialog = ({onClose}: Props) => {
   const {t} = useTranslation();
   const classes = useStyles();

   const {request, state: data} = usePostApi<IMfaSetupResponse>(api.mfaSetup);

   React.useEffect(() => {
      request(null);
   }, [request]);

   const onSubmit = useVerifyCode(onClose);

   return (
      <Dialog maxWidth="sm" header={t('Add Authenticator App')}>
         <div className={classes.root}>
            {/* <Typography variant="h1">{}</Typography> */}
            <Typography variant="overline" gutterBottom>
               {t(
                  'Your account requires two-factor authentication to log in, using an Authenticator app.\nPlease follw these instructions to set up your authenticator app for logging in.'
               )}
            </Typography>
            <Panel name={t('Step 1: Scan this QR Code')}>
               <Typography gutterBottom>
                  {t(
                     'Scan the following QR code into your authenticator app, such as Microsoft Authenticator, Google Authenticator, Duo Mobile, Authy, Okta Verify, LastPass Authenticator, etc.'
                  )}
               </Typography>

               <Box sx={{textAlign: 'center'}}>
                  <img src={data?.qrCodeUri} />
               </Box>
            </Panel>

            <Panel name={t('Step 2: Save these backup codes')}>
               <Typography gutterBottom>
                  {t(
                     'In the event that your authenticator app is unavailable, you can use these backup codes at any time to log in. Store these safely in a password manager to ensure you can log in.'
                  )}
               </Typography>
               <Grid
                  container
                  spacing={1}
                  flexDirection="column"
                  wrap="wrap"
                  justifyContent="center"
                  alignItems="center"
                  maxHeight={200}
               >
                  {data?.recoveryCodes.map((code) => (
                     <Grid item key={code}>
                        {code}
                     </Grid>
                  ))}
               </Grid>
            </Panel>

            <Panel name={t('Step 3: Enter the one-time code')}>
               <AuthenticatorForm onSubmit={onSubmit} onClose={onClose} />
            </Panel>
         </div>
      </Dialog>
   );
};
